import React from 'react';
import {
  BreadcrumbLink,
  BreadcrumbsItem,
  BreadcrumbsList,
  BreadcrumbsSection,
  BreadcrumbText
} from './styled';
import { CurrentItemBreadcrumbsProps } from './types';
import { BreadcrumbSchema } from './BreadcrumbSchema';

const breadcrumbsMap = {
  1: 'first',
  2: 'second',
  3: 'third',
  4: 'fourth'
};

export const CurrentItemBreadcrumbs: React.FC<CurrentItemBreadcrumbsProps> = ({
  breadcrumbs = [],
  title
}) => (
  <>
    <BreadcrumbSchema breadcrumbs={breadcrumbs} title={title} />
    <BreadcrumbsSection data-cy="current-item-breadcrumbs">
      <BreadcrumbsList data-cy="current-item-breadcrumbs-list">
        {breadcrumbs?.map(({ path, name }, i) => {
          const Component = path ? BreadcrumbLink : BreadcrumbText;

          return (
            <BreadcrumbsItem
              data-cy="current-item-breadcrumbs-list-item"
              key={i}
            >
              <Component
                href={path}
                tag="body_2"
                data-stat={`item-breadcrumbs-mob-${breadcrumbsMap[i + 1]}`}
              >
                {name}
              </Component>
            </BreadcrumbsItem>
          );
        })}
      </BreadcrumbsList>
    </BreadcrumbsSection>
  </>
);
